import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import { eligibleAnalytics, useAnalyticsFavorites } from "../lib/analyticsFavorites";
import "./QuickAccess.css";

export const FavoriteEntryContext = createContext(null);
export function FavoriteButton({ target, entry: explicitEntry }) {
  const context = useContext(FavoriteEntryContext);
  const location = useLocation();
  const tab = new URLSearchParams(location.search).get("tab") || "overview";
  const entry = explicitEntry || (context?.target === target ? context : null) || eligibleAnalytics.find(item => item.tab === (context?.tab || tab) && item.target === target);
  const { ids, toggle, enabled, error } = useAnalyticsFavorites();
  if (!enabled || !entry?.favoriteEligible) return null;
  const saved = ids.includes(entry.id);
  const label = `${saved ? "Remove from" : "Add to"} Quick Access: ${entry.title}`;
  return <span className="analytics-favorite-control">
    <button type="button" className={`analytics-favorite-button ${saved ? "is-favorite" : ""}`}
      aria-label={label} title={error || label} aria-pressed={saved}
      onClick={event => { event.stopPropagation(); toggle(entry.id); }}>
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" fill={saved ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"><path d="m12 3 2.8 5.7 6.3.9-4.5 4.4 1.1 6.2-5.7-3-5.7 3 1.1-6.2L3.2 9.6l6.3-.9L12 3Z" /></svg>
    </button>
    {error && <span role="alert" className="analytics-favorite-error">Favorites not saved</span>}
  </span>;
}
export function FavoriteAnalyticsShell({ entry, children }) {
  return <div className="favorite-analytics-shell">
    <div className="favorite-analytics-toolbar"><FavoriteButton entry={entry} /></div>
    {children}
  </div>;
}
